/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

import * as React from 'react'

import { MarkdownIcon } from '@tinacms/icons'
import { MenuButton } from '../MenuHelpers/MenuButton'
import { useEditorModeContext } from '../../context/editorMode'

export const EditorModeMenu = () => {
  const { mode, setMode } = useEditorModeContext()

  const toggleMode = () => {
    if (mode === 'markdown') setMode('wysiwyg')
    else setMode('markdown')
  }

  return (
    <MenuButton
      data-testid="markdown-toggle"
      data-tooltip={'Markdown mode'}
      onClick={toggleMode}
    >
      <MarkdownIcon />
    </MenuButton>
  )
}
